module.exports = __webpack_public_path__ + "img/relatorio.70c7b2b9.svg";